export default __webpack_public_path__ + "icon_my_volvo.6473e9fbd0aa089127314e77319005a5.svg";